import React from 'react';
import { motion } from 'framer-motion';
import {
  TrendDown,
  TrendUp
} from '@phosphor-icons/react';

const AnalyticsKpiCard = ({ icon: Icon, label, value, unit, trend, loading }) => {
  if (loading) {
    return (
      <div className="glass rounded-2xl p-6 animate-pulse">
        <div className="h-8 w-8 bg-[rgba(255,255,255,0.1)] rounded-full mb-3"></div>
        <div className="h-4 w-24 bg-[rgba(255,255,255,0.1)] rounded mb-2"></div>
        <div className="h-8 w-32 bg-[rgba(255,255,255,0.1)] rounded"></div>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="glass rounded-2xl p-6 hover:bg-[rgba(255,255,255,0.08)] transition-all"
    >
      <div className="flex items-start justify-between mb-3">
        <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#6366F1] to-[#EC4899] flex items-center justify-center">
          <Icon size={24} className="text-white" />
        </div>
        {trend && (
          <div className={`flex items-center gap-1 text-xs font-semibold ${
            trend > 0 ? 'text-[#14F195]' : trend < 0 ? 'text-[#EF4444]' : 'text-[#A0AEC0]'
          }`}>
            {trend > 0 ? (
              <TrendUp size={14} />
            ) : trend < 0 ? (
              <TrendDown size={14} />
            ) : null}
            {Math.abs(trend)}%
          </div>
        )}
      </div>
      <p className="text-[#A0AEC0] text-sm mb-1">{label}</p>
      <div className="flex items-baseline gap-2">
        <h3 className="text-3xl font-bold text-white">{value}</h3>
        {unit && <span className="text-[#A0AEC0] text-sm">{unit}</span>}
      </div>
    </motion.div>
  );
};

export default AnalyticsKpiCard;
